import React, { Component } from "react";
import { Row, Col, Button, Form, Modal, Alert } from "react-bootstrap";
import {
  CadastrarHorarioFuncionamento,
  EditarHorarioFuncionamento,
  DeletarHorarioFuncionamento,
} from "../../providers/HorariosFuncionamentoProvider";
import { getUser, setUser } from "../../services/Auth";
import Select from "react-select";
import { toast } from "react-toastify";
import TBLHorarios from "../../components/TBLHorarios";
import { FormControlLabel, Switch } from "@material-ui/core";

const diasOptions = [
  { value: 1, label: "Segunda" },
  { value: 2, label: "Terça" },
  { value: 3, label: "Quarta" },
  { value: 4, label: "Quinta" },
  { value: 5, label: "Sexta" },
  { value: 6, label: "Sábado" },
  { value: 0, label: "Domingo" },
];

const horarioOptions = [
  { value: 0, label: "00:00" },
  { value: 1, label: "01:00" },
  { value: 2, label: "02:00" },
  { value: 3, label: "03:00" },
  { value: 4, label: "04:00" },
  { value: 5, label: "05:00" },
  { value: 6, label: "06:00" },
  { value: 7, label: "07:00" },
  { value: 8, label: "08:00" },
  { value: 9, label: "09:00" },
  { value: 10, label: "10:00" },
  { value: 11, label: "11:00" },
  { value: 12, label: "12:00" },
  { value: 13, label: "13:00" },
  { value: 14, label: "14:00" },
  { value: 15, label: "15:00" },
  { value: 16, label: "16:00" },
  { value: 17, label: "17:00" },
  { value: 18, label: "18:00" },
  { value: 19, label: "19:00" },
  { value: 20, label: "20:00" },
  { value: 21, label: "21:00" },
  { value: 22, label: "22:00" },
  { value: 23, label: "23:00" },
];

export default class HorariosFuncionamento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      horariosFuncionamento: [],
      horarioSelecionado: null,
      mensagemAlert: "",
      variantAlert: "",
      diaSelecionado: null,
      horarioIniManha: null,
      horarioFimManha: null,
      horarioIniTarde: null,
      horarioFimTarde: null,
      entregaExpressaDisponivel: true,
      entregaAgendadaDisponivel: true,
      entregaProgramadaDisponivel: false,
      erro: {
        dia: null,
        diaSelecionado: null,
        horarioIniManha: null,
        horarioFimManha: null,
        horarioIniTarde: null,
        horarioFimTarde: null,
      },
      isEdit: false,
    };
  }

  handleCloseModalHorario = () => {
    this.setState({ showModalHorario: false, isEdit: false });
    this.limparForm();
  };

  handleShowModalHorario = (isEdit) => {
    this.setState({ showModalHorario: true, isEdit });
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = () => {
    this.setState({ showModalAlert: true });
  };

  preencherFormEdit = (dados) => {
    let isTardeOnly = dados.horarios[0] ? dados.horarios[0].hora_inicio >= 12 : false;
    if (isTardeOnly) {
      this.setState({
        horarioSelecionado: dados,
        diaSelecionado: diasOptions.find((h) => h.value == dados.num_dia || null),
        horarioIniTarde: horarioOptions.find(
          (h) => h.value == (dados.horarios[0] ? dados.horarios[0].hora_inicio : null),
        ),
        horarioFimTarde: horarioOptions.find(
          (h) => h.value == (dados.horarios[0] ? dados.horarios[0].hora_fim : null),
        ),
        entregaAgendadaDisponivel: dados.entrega_agendada_ativa,
        entregaExpressaDisponivel: dados.entrega_expressa_ativa,
        entregaProgramadaDisponivel: dados.entrega_programada_ativa,
      });
    } else {
      this.setState({
        horarioSelecionado: dados,
        diaSelecionado: diasOptions.find((h) => h.value == dados.num_dia || null),
        horarioIniManha: horarioOptions.find(
          (h) => h.value == (dados.horarios[0] ? dados.horarios[0].hora_inicio : null),
        ),
        horarioFimManha: horarioOptions.find(
          (h) => h.value == (dados.horarios[0] ? dados.horarios[0].hora_fim : null),
        ),
        horarioIniTarde: horarioOptions.find(
          (h) => h.value == (dados.horarios[1] ? dados.horarios[1].hora_inicio : null),
        ),
        horarioFimTarde: horarioOptions.find(
          (h) => h.value == (dados.horarios[1] ? dados.horarios[1].hora_fim : null),
        ),
        entregaAgendadaDisponivel: dados.entrega_agendada_ativa,
        entregaExpressaDisponivel: dados.entrega_expressa_ativa,
        entregaProgramadaDisponivel: dados.entrega_programada_ativa,
      });
    }
    this.handleShowModalHorario(true);
  };

  receberDadosTabela = (tipo, dados) => {
    if (tipo === "deletar") {
      this.setState({ horarioSelecionado: dados });
      this.handleShowModalAlert();
    }
    if (tipo === "editar") {
      this.preencherFormEdit(dados);
      this.handleShowModalHorario(true);
    } else {
      return;
    }
  };

  validarForm = () => {
    let diaSelecionadoError = false;
    let horarioIniManhaError = false;
    let horarioFimManhaError = false;
    let horarioIniTardeError = false;
    let horarioFimTardeError = false;
    let horarioManhaSelecionado =
      this.state.horarioIniManha && this.state.horarioFimManha;
    let horarioTardeSelecionado =
      this.state.horarioIniTarde && this.state.horarioFimTarde;
    if (!this.state.diaSelecionado) {
      diaSelecionadoError = true;
    }
    if (!this.state.horarioIniManha && !horarioTardeSelecionado) {
      horarioIniManhaError = true;
    }
    if (!this.state.horarioFimManha && !horarioTardeSelecionado) {
      horarioFimManhaError = true;
    }
    if (!this.state.horarioIniTarde && !horarioManhaSelecionado) {
      horarioIniTardeError = true;
    }
    if (!this.state.horarioFimTarde && !horarioManhaSelecionado) {
      horarioFimTardeError = true;
    }
    this.setState({
      erro: {
        diaSelecionado: diaSelecionadoError ? "Campo obrigatório" : null,
        horarioIniManha: horarioIniManhaError ? "Campo obrigatório" : null,
        horarioFimManha: horarioFimManhaError ? "Campo obrigatório" : null,
        horarioIniTarde: horarioIniTardeError ? "Campo obrigatório" : null,
        horarioFimTarde: horarioFimTardeError ? "Campo obrigatório" : null,
      },
    });
    return (
      diaSelecionadoError ||
      horarioIniManhaError ||
      horarioFimManhaError ||
      horarioIniTardeError ||
      horarioFimTardeError
    );
  };

  cadastrarHorario = async () => {
    if (!this.validarForm()) {
      let horarioManhaSelecionado =
        this.state.horarioIniManha && this.state.horarioFimManha;
      let horarioTardeSelecionado =
        this.state.horarioIniTarde && this.state.horarioFimTarde;
      let horarios = [];
      if (horarioManhaSelecionado) {
        horarios.push({
          hora_inicio: this.state.horarioIniManha.value,
          hora_fim: this.state.horarioFimManha.value,
        });
      }
      if (horarioTardeSelecionado) {
        horarios.push({
          hora_inicio: this.state.horarioIniTarde.value,
          hora_fim: this.state.horarioFimTarde.value,
        });
      }
      const data = {
        num_dia: this.state.diaSelecionado.value,
        desc_dia: this.state.diaSelecionado.label,
        entrega_expressa_ativa: this.state.entregaProgramadaDisponivel
          ? false
          : this.state.entregaExpressaDisponivel,
        entrega_agendada_ativa: this.state.entregaProgramadaDisponivel
          ? false
          : this.state.entregaAgendadaDisponivel,
        entrega_programada_ativa: this.state.entregaProgramadaDisponivel,
        horarios: horarios,
      };
      try {
        const response = await CadastrarHorarioFuncionamento(data);
        if (response) {
          this.handleShowAlert("Horário cadastrado com sucesso", "success");
          const usuario = await getUser();
          usuario.estabelecimento = response;
          await setUser(usuario);
          window.location.reload();
        }
      } catch (error) {
        this.handleShowAlert("Erro ao cadastrar horário", "danger");
      }
    }
  };

  editarHorario = async () => {
    if (!this.validarForm()) {
      let horarioManhaSelecionado =
        this.state.horarioIniManha && this.state.horarioFimManha;
      let horarioTardeSelecionado =
        this.state.horarioIniTarde && this.state.horarioFimTarde;
      let horarios = [];
      if (horarioManhaSelecionado) {
        horarios.push({
          hora_inicio: this.state.horarioIniManha.value,
          hora_fim: this.state.horarioFimManha.value,
        });
      }
      if (horarioTardeSelecionado) {
        horarios.push({
          hora_inicio: this.state.horarioIniTarde.value,
          hora_fim: this.state.horarioFimTarde.value,
        });
      }
      const data = {
        num_dia: this.state.diaSelecionado.value,
        desc_dia: this.state.diaSelecionado.label,
        entrega_expressa_ativa: this.state.entregaProgramadaDisponivel
          ? false
          : this.state.entregaExpressaDisponivel,
        entrega_agendada_ativa: this.state.entregaProgramadaDisponivel
          ? false
          : this.state.entregaAgendadaDisponivel,
        entrega_programada_ativa: this.state.entregaProgramadaDisponivel,
        horarios: horarios,
      };
      try {
        const idHorario = this.state.horarioSelecionado._id;
        const response = await EditarHorarioFuncionamento(idHorario, data);
        if (response) {
          this.handleShowAlert("Horário editado com sucesso", "success");
          const usuario = await getUser();
          usuario.estabelecimento = response;
          await setUser(usuario);
          window.location.reload();
        }
      } catch (error) {
        this.handleShowAlert("Erro ao editar horário", "danger");
      }
    }
  };

  deletarHorario = async () => {
    try {
      const idHorario = this.state.horarioSelecionado._id;
      const response = await DeletarHorarioFuncionamento(idHorario);
      if (response) {
        this.handleShowAlert("Horário deletado com sucesso", "success");
        const usuario = await getUser();
        usuario.estabelecimento = response;
        await setUser(usuario);
        window.location.reload();
      }
    } catch (error) {
      this.handleShowAlert("Erro ao deletar horário", "danger");
    }
  };

  async componentDidMount() {
    const usuario = await getUser();
    if (usuario && usuario.estabelecimento) {
      let horarios = usuario.estabelecimento.horario_funcionamento.sort((a, b) =>
        a.num_dia < b.num_dia ? -1 : 1,
      );
      this.setState({ horariosFuncionamento: horarios });
    }
  }

  limparForm = () => {
    this.setState({
      diaSelecionado: null,
      horarioIniManha: null,
      horarioFimManha: null,
      horarioIniTarde: null,
      horarioFimTarde: null,
      entregaExpressaDisponivel: true,
      entregaAgendadaDisponivel: true,
      entregaProgramadaDisponivel: false,
      erro: {
        dia: null,
        diaSelecionado: null,
        horarioIniManha: null,
        horarioFimManha: null,
        horarioIniTarde: null,
        horarioFimTarde: null,
      },
      mensagemAlert: "",
      variantAlert: "",
    });
  };

  render() {
    return (
      <div>
        {this.state.showAlert ? (
          <Alert style={{ zIndex: 99999999999 }} variant={this.state.variantAlert}>
            {this.state.mensagemAlert}
          </Alert>
        ) : null}
        <br></br>
        <Row>
          <Col>
            <h3>Horários de funcionamento</h3>
          </Col>
          <Col style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={() => {
                this.handleShowModalHorario();
              }}
            >
              Cadastrar horário
            </Button>
          </Col>
        </Row>
        <br></br>
        <div>
          <Row>
            <Col>
              <Form.Label>
                <b>Horário de Funcionamento: </b>
              </Form.Label>
            </Col>
          </Row>
          <Row>
            <Col>
              <TBLHorarios
                data={this.state.horariosFuncionamento}
                dataCallback={this.receberDadosTabela}
                numRows={7}
              />
            </Col>
          </Row>
          <br></br>
        </div>
        <Modal
          size="lg"
          show={this.state.showModalHorario}
          onHide={this.handleCloseModalHorario}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.isEdit
                ? "Editar horário de funcionamento"
                : "Cadastrar horário de funcionamento"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group controlId="formHorario">
                <Row>
                  <Col>
                    <Form.Label>Dia da semana</Form.Label>
                    <Select
                      value={this.state.diaSelecionado}
                      options={diasOptions}
                      onChange={(e) => this.setState({ diaSelecionado: e })}
                      isClearable={true}
                      placeholder="Dia da semana"
                    ></Select>
                    {this.state.erro.diaSelecionado ? (
                      <div>
                        <p style={{ color: "red" }}>{this.state.erro.diaSelecionado}</p>
                      </div>
                    ) : null}
                  </Col>
                </Row>
                <br></br>
                <Row>
                  <Col>
                    <FormControlLabel
                      value={this.state.entregaProgramadaDisponivel}
                      control={
                        <Switch
                          color="primary"
                          checked={this.state.entregaProgramadaDisponivel}
                          onChange={(e) =>
                            this.setState({
                              entregaProgramadaDisponivel: e.target.checked,
                            })
                          }
                        />
                      }
                      label="Entrega Programada ativa"
                      labelPlacement="start"
                    />
                    <Form.Text>
                      Entrega pro próximo dia útil sem horário definido
                    </Form.Text>
                  </Col>
                </Row>
                <br></br>
                <>
                  <h4>Horário da manhã</h4>
                  <Row>
                    <Col>
                      <Form.Label>Horário inicial</Form.Label>
                      <Select
                        value={this.state.horarioIniManha}
                        options={horarioOptions}
                        onChange={(e) => this.setState({ horarioIniManha: e })}
                        isClearable={true}
                        placeholder="Horário inicial"
                      ></Select>
                      {this.state.erro.horarioIniManha ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.erro.horarioIniManha}
                          </p>
                        </div>
                      ) : null}
                    </Col>
                    <Col>
                      <Form.Label>Horário final</Form.Label>
                      <Select
                        value={this.state.horarioFimManha}
                        options={
                          this.state.horarioIniManha
                            ? horarioOptions.filter(
                                (h) => h.value > this.state.horarioIniManha.value,
                              )
                            : horarioOptions
                        }
                        onChange={(e) => this.setState({ horarioFimManha: e })}
                        isClearable={true}
                        placeholder="Horário final"
                      ></Select>
                      {this.state.erro.horarioFimManha ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.erro.horarioFimManha}
                          </p>
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                  <br></br>
                  <h4>Horário da tarde</h4>
                  <Row>
                    <Col>
                      <Form.Label>Horário inicial</Form.Label>
                      <Select
                        value={this.state.horarioIniTarde}
                        options={
                          this.state.horarioFimManha
                            ? horarioOptions.filter(
                                (h) => h.value > this.state.horarioFimManha.value,
                              )
                            : horarioOptions
                        }
                        onChange={(e) => this.setState({ horarioIniTarde: e })}
                        isClearable={true}
                        placeholder="Horário inicial"
                      ></Select>
                      {this.state.erro.horarioIniTarde ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.erro.horarioIniTarde}
                          </p>
                        </div>
                      ) : null}
                    </Col>
                    <Col>
                      <Form.Label>Horário final</Form.Label>
                      <Select
                        value={this.state.horarioFimTarde}
                        options={
                          this.state.horarioIniTarde
                            ? horarioOptions.filter(
                                (h) => h.value > this.state.horarioIniTarde.value,
                              )
                            : horarioOptions
                        }
                        onChange={(e) => this.setState({ horarioFimTarde: e })}
                        isClearable={true}
                        placeholder="Horário final"
                      ></Select>
                      {this.state.erro.horarioFimTarde ? (
                        <div>
                          <p style={{ color: "red" }}>
                            {this.state.erro.horarioFimTarde}
                          </p>
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                  <br></br>
                  {!this.state.entregaProgramadaDisponivel && (
                    <>
                      <Row>
                        <Col>
                          <FormControlLabel
                            value={this.state.entregaExpressaDisponivel}
                            control={
                              <Switch
                                color="primary"
                                checked={this.state.entregaExpressaDisponivel}
                                onChange={(e) =>
                                  this.setState({
                                    entregaExpressaDisponivel: e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Entrega Expressa ativa"
                            labelPlacement="start"
                          />
                        </Col>
                        <Col>
                          <FormControlLabel
                            value={this.state.entregaAgendadaDisponivel}
                            control={
                              <Switch
                                color="primary"
                                checked={this.state.entregaAgendadaDisponivel}
                                onChange={(e) =>
                                  this.setState({
                                    entregaAgendadaDisponivel: e.target.checked,
                                  })
                                }
                              />
                            }
                            label="Agendamento Ativo"
                            labelPlacement="start"
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                </>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalHorario();
              }}
            >
              Fechar
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                if (this.state.isEdit) {
                  this.editarHorario();
                } else {
                  this.cadastrarHorario();
                }
              }}
            >
              {this.state.isEdit ? "Editar" : "Cadastrar"}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Deseja realmente excluir o Horário?</p>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                this.deletarHorario();
              }}
            >
              Sim
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
